import { query } from "./query";

export const blogDetailPageQuery = {
  query,
  mocks: {
    defaultData: null,
  },
};
